import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GenericItem } from '../types/items';
import { useGuard } from './index';
import { is, roles } from '../utility/guard';
import { selectLists } from '../store/modules/lists/selectors';
import { selectProject } from '../store/modules/projects/selectors';
import { noAdminProjectStatuses } from '../views/projects/constants';

const useProjectStatuses = (): Array<GenericItem<string | number>> | null => {
  const isSuperAdmin = useGuard(is(roles.superAdmin));
  const lists = useSelector(selectLists);
  const { data: project } = useSelector(selectProject);
  const statusId = project!.status_id;
  const currentStatusList = [...noAdminProjectStatuses, statusId];

  return useMemo(() => (lists.data ? lists.data['project-status']
    .map((item):GenericItem<number> => ({ id: item.key, title: item.value }))
    .filter((item) => item.id !== 0 && item.id !== -1)
    .filter((item) => (isSuperAdmin ? true : currentStatusList.includes(item.id)))
    : []), [isSuperAdmin, lists, currentStatusList]);
};

export default useProjectStatuses;
